
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M36.522 33.506c2.25-2.413 3.476-5.398 3.476-8.506 0-3.89-1.922-7.414-5-9.914C34.928 24 26.547 31.25 16.25 31.25H9.282c2.695 4.445 8.171 7.5 14.468 7.5h14.998c.508 0 .96-.306 1.156-.774a1.236 1.236 0 00-.273-1.36l-3.11-3.109z","fill":"#1B342C"}}),_c('path',{attrs:{"d":"M16.25 1.252C7.29 1.252.002 7.415.002 15c0 3.109 1.226 6.085 3.476 8.507L.37 26.617c-.36.359-.469.898-.273 1.359a1.25 1.25 0 001.156.773H16.25c8.96 0 16.249-6.163 16.249-13.748 0-7.586-7.289-13.75-16.249-13.75z","fill":"#1BB58B"}}),_c('path',{attrs:{"d":"M23.75 11.251H8.75c-.687 0-1.25.562-1.25 1.25 0 .687.563 1.25 1.25 1.25H23.75c.687 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25zM18.75 16.25H8.751c-.687 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25h10c.686 0 1.249-.562 1.249-1.25 0-.687-.563-1.25-1.25-1.25z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    